import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import Pagination from 'components/Libs/Pagination';
import styles from 'styles';
import { TextField, Table, TableBody, TableHeaderColumn, TableRow, TableRowColumn, TableHeader } from 'material-ui';
import helpers from 'helpers';

class InfoGazetters extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            rowsPerPage: [10, 20, 30, 50, 100],
            rows: [],
            numberOfRows: 10,
            page: 1,
            total: undefined,
            gazetters: props.gazetters,
            search: '',
        };

        this.onSearch = this.onSearch.bind(this);
        this.handleUpdateRow = this.handleUpdateRow.bind(this);
    }

    componentDidMount() {
        this.setState({
            total: this.props.gazetters.length,
            gazetters: helpers.filterSearch(this.props.gazetters, this.state.search, ['gazetteerName', 'fileName', 'gazType', 'status', 'value']),
            page: 1,
        }, () => {
            this.handleUpdateRow(this.state);
        });
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            total: props.gazetters.length,
            gazetters: helpers.filterSearch(props.gazetters, this.state.search, ['gazetteerName', 'fileName', 'gazType', 'status', 'value']),
            page: 1,
        }, () => {
            this.handleUpdateRow(this.state);
        });
    }

    changeRowsByPagination(state) {
        const elementsOnPage = state.numberOfRows;
        const offset = state.page - 1;
        const from = offset * elementsOnPage;
        const to = (offset * elementsOnPage) + elementsOnPage;

        return this.state.gazetters.slice(from, to);
    }

    onSearch(e, value) {
        this.setState({
            search: value,
            total: this.props.gazetters.length,
            gazetters: helpers.filterSearch(this.props.gazetters, value, ['gazetteerName', 'fileName', 'gazType', 'status', 'value']),
            page: 1,
        }, () => {
            this.handleUpdateRow(this.state);
        });
    }

    handleUpdateRow(state) {
        const cloneState = _.cloneDeep(state);

        this.setState({
            ...cloneState,
            rows: this.changeRowsByPagination(cloneState),
        });
    }

    render() {
        const {
            search, gazetters, rows, rowsPerPage, numberOfRows, page, 
        } = this.state;

        return (
            <div className='paper-block margin-10'>
                <span className='name-block absolute'>Gazetters</span>

                <div className='row'>
                    <div className='col-xs-6'>
                        <TextField
                            value={search}
                            floatingLabelText='Search'
                            onChange={this.onSearch}
                        />
                    </div>
                    <div className='col-xs-6'>
                        <Pagination
                            total={gazetters.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            numberOfRows={numberOfRows}
                            updateRows={this.handleUpdateRow}
                        />
                    </div>
                </div>
                <div className='paper-block margin-10'>
                    <Table selectable={false}>
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                            <TableRow>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    date
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    GazetterName
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    fileName
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    gazType
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    status
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    value
                                </TableHeaderColumn>
                            </TableRow>
                        </TableHeader>
                        <TableBody displayRowCheckbox={false}>
                            { rows.map((gazetter, index) => (
                                <TableRow key={index}>
                                    <TableRowColumn style={styles.tableRowColumnCSS}>
                                        {moment(gazetter.date).format('DD.MM.YYYY HH.mm.ss')}
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.tableRowColumnCSS}>
                                        {gazetter.gazetteerName}
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.tableRowColumnCSS}>
                                        {gazetter.fileName}
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.tableRowColumnCSS}>
                                        {gazetter.gazType}
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.tableRowColumnCSS}>
                                        {gazetter.status}
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.tableRowColumnCSS}>
                                        {gazetter.value}
                                    </TableRowColumn>

                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </div>

        );
    }
}

export default connect(
    (state, { requests }) => ({
        requests,
    }),
    dispatch => bindActionCreators({}, dispatch),
)(InfoGazetters);



// WEBPACK FOOTER //
// ./app/components/Statistics/St/Info/Gazetters.jsx